import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { EditLockService } from '../../lock/edit-lock.service';

@Component({
  selector: 'app-browser-kop-wrapper',
  templateUrl: './browser-kop-wrapper.component.html',
  styles: ``
})
export class BrowserKopWrapperComponent {
  constructor(private router: Router, private editLockService: EditLockService) {
    const url = this.router.url;
    if (url !== url.toUpperCase()) {
      this.router.navigateByUrl(url.toUpperCase());
    }
  }


  onKopInvalid() {
    this.editLockService.unlock();
  }
}
